'use client';

import { useEffect } from 'react';

import LoadingFullScreen from 'components/LoadingFullScreen';

function Page() {
	// Effects
	useEffect(() => {
		window.location.href = 'https://docs.giteai.dev';
	}, []);

	return <LoadingFullScreen />;
}

export default Page;
